import React from "react";

import { useSelector } from "react-redux";
import ProgressBar from "react-customizable-progressbar";
import JDate from "jalali-date";

import styles from "../../styles/speedometer.module.css";

const Speedometer = () => {
    const position = useSelector((state) => state.speedometer.position);
    const route = useSelector((state) => state.routes.positions);
    const user = useSelector((state) => state.session.user);

    const HaveRoute = route.length ? true : false;
    if (!HaveRoute || !position) return [];

    let speed = Math.round(position.speed * 1.852);
    const insertDate = new Date(position.deviceTime);

    return (
        <div className={styles.speed} style={{ bottom: 140 + (user.administrator ? 60 : 0) + "px" }}>
            <ProgressBar
                radius={70}
                progress={speed}
                strokeWidth={20}
                strokeColor={speed < 30 ? "#00FF66" : speed < 80 ? "#FFCC00" : "#FF2A2A"}
                strokeLinecap="round"
                trackStrokeWidth={20}
                trackStrokeLinecap="round"
                cut={120}
                rotate={-210}
                transition={"0.7s ease"}
                steps={200}
            >
                <div className={styles.indicator}>
                    {speed} Km/h
                    <br />
                    {new JDate(insertDate).format("dddd DD MMMM")}
                    <br />
                    {"ساعت " + insertDate.getHours() + ":" + insertDate.getMinutes() + ":" + insertDate.getSeconds()}
                </div>
            </ProgressBar>
        </div>
    );
};

export default Speedometer;
